export default __webpack_public_path__ + "static/media/xbox.e3cc1e26.svg";